/**
 * Sliders Script
 */

import Glide from '@glidejs/glide'


document.addEventListener('DOMContentLoaded', function () {


	if ( 0 < document.querySelectorAll('.gslides').length ) {

		const options = {
			type: 'carousel',
			startAt: 0,
			perView: 1,
			animationDuration: 800,
			gap: 0,
			hoverpause: false
		}
	  
	  const carousels = document.querySelectorAll('.gslides');
	  
	  Object.values(carousels).map(carousel => {
			var newCarousel = new Glide(carousel, options);

			// Resize height
			function glideHandleHeight() {
				const activeSlide = carousel.querySelector('.glide__slide--active');
				const activeSlideHeight = activeSlide ? activeSlide.offsetHeight : 0;
		
				const glideTrack = carousel.querySelector('.glide__track');
				const glideTrackHeight = glideTrack ? glideTrack.offsetHeight : 0;
		
				if (activeSlideHeight !== glideTrackHeight) {
					glideTrack.style.height = `${activeSlideHeight}px`;
				}
			}

			carousel.querySelector('.glide__track').setAttribute('data-glide-el', 'track');

			newCarousel.on('build.before', function() {

				if ( !carousel.querySelector('.glide__arrows') ) {

					const arrowsWrapper = document.createElement('div')
					arrowsWrapper.className = 'glide__arrows';
					arrowsWrapper.dataset.glideEl = 'controls'
					arrowsWrapper.innerHTML = `<button class="glide__arrow glide__arrow--left" data-glide-dir="<">prev</button><button class="glide__arrow glide__arrow--right" data-glide-dir=">">next</button>`

					carousel.appendChild(arrowsWrapper)

					var bulletCount = carousel.querySelectorAll('.glide__slide').length;
		
					const bulletsWrapper = document.createElement('div')
					bulletsWrapper.className = 'glide__bullets';
					bulletsWrapper.dataset.glideEl = 'controls[nav]'
		
					for (let index = 0; index < bulletCount; index++) {

					  const button = document.createElement('button');
					  button.className = 'glide__bullet';
					  button.setAttribute('data-glide-dir', '=' + index);
					  button.setAttribute('aria-label', 'Go to Slide ' + ( index + 1 ) );
					  bulletsWrapper.appendChild(button);
		
					  if ( index === bulletCount - 1 ) {
						carousel.appendChild(bulletsWrapper)
					  }

					}
				}
	
			});

			// Automated height on Carousel build
			newCarousel.on('build.after', function (e) {
				glideHandleHeight();
			});
		
			// Automated height on Carousel change
			newCarousel.on('run.after', function () {
				glideHandleHeight();
			});
	
			newCarousel.mount()
	  });

	}
	
}, false);